<template>
  <v-layout row align-center>
    <v-flex xs12>
      <v-card class="pa-4">
        <v-alert color="error" :value="true" class="err" icon="warning" type="error" v-if="err">
          {{err}}
        </v-alert>
        <v-alert color="error" :value="true" class="err" icon="warning" type="error" v-if="errors.length > 0">
          <span v-for="err in errors">{{err.message}}.<br></span>
        </v-alert>
        <transition name="fade">
          <v-alert type="success" :value="true"  v-if="success">
            {{success}}
          </v-alert>
        </transition>
        <v-flex v-if="(this.$route.query.id) && !loaded" text-xs-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-flex>
        <div v-else>
          <template v-if="!isLocalAdmin">
            <h2>{{ $lang.labels.company }}</h2>
            <v-layout row>
              <v-flex
                v-if="companies.length > 0"
                style=" z-index: 5;"
                grow
                class="text-xs-center">
                <v-btn
                  flat
                  block
                  :disabled="!!$route.query.id && !currentCorporation"
                  outline
                  :class="{ 'v-btn--disabled': $route.query.id && !currentCorporation }"
                  class="elevation-0 "
                  @click="show = !show"
                  type="button"
                  >
                  {{ selectedCompany ? selectedCompany.name : $lang.labels.selectCompany }}
                </v-btn>
                <v-list
                  style="box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12); margin-top: -6px;"
                  v-show="show">
                  <v-list-tile @click.stop class="search pt-0">
                    <v-text-field type="text" :label="$lang.labels.filterCategories" v-model="filter"></v-text-field>
                  </v-list-tile>
                  <v-list-tile
                    v-for="company in filteredCompanies"
                    :key="company.id"
                    v-if="!selectedCompany || selectedCompany.id !== company.id"
                    @click="selectCompany(company)">
                    <v-list-tile-title>{{company.name}} ({{company.companyStatus}})</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-btn
                color="primary"
                class="elevation-0 "
                @click="show = !show">
                {{ $lang.actions.changeCompany }}
              </v-btn>
            </v-layout>
          </template>
          <v-layout row wrap align-start justify-space-between class="my-4">
            <v-flex xs12 sm4>
              <h2 class="mr-3">{{ $lang.header.catalogName }}</h2>
              <v-text-field
                :placeholder="$lang.labels.name1"
                type="text"
                v-model="name"
                @blur="name = name.trim()">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4 v-if="version" pl-4>
              <h2 class="mb-3">{{ $lang.header.originalVersion }}</h2>
              <p class="ma-0">{{version}}</p>
            </v-flex>
            <v-flex xs12 sm4 class="d-inline-flex">
              <v-btn color="primary" @click="copyWholeCatalog()">
                {{ $lang.actions.copyCatalog }}
              </v-btn>
              <v-btn color="primary" @click="turnOnPasteListen()">
                {{ isPasteOn ? $lang.actions.pasteCatalogTurnOff : $lang.actions.pasteCatalogTurnOn }}
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row align-center justify-space-between class="my-4">
            <div class="d-inline-flex">
              <h2 class="mr-3 pt-1 mt-2">{{ $lang.header.views }}</h2>
              <v-btn fab dark small color="primary" @click="editViews = true; currentView = null">
                <v-icon>add</v-icon>
              </v-btn>
            </div>
            <v-btn dark color="primary" @click="predefinedViewsModal = true">
              {{ $lang.labels.predefinedViews}}
            </v-btn>
          </v-layout>
          <v-layout row wrap class="views pa-3" @click="editViewToggle">
            <p class="m-0" v-if="views.length === 0">{{ $lang.actions.addViews }}</p>
            <div class="py-1 px-3 ma-0 my-1 mr-2 views--item" v-for="(view, index) in views" :key="index">
              {{view.name[language]}}
              <small v-if="typeof view.viewId !== 'undefined'">({{ view.viewId }})</small>
              <small v-if="view.isDefault" v-text="'<Default>'"></small>
              <v-icon class="ml-2" @click.stop="editView(view, index)">edit</v-icon>
              <v-icon @click.stop="deleteView(view.viewId)">delete</v-icon>
            </div>
          </v-layout>
          <v-layout row align-center class="my-4">
            <h2 class="mr-3">{{ $lang.header.allergens }}</h2>
            <v-btn fab dark small color="primary" @click="editAllergens = true; currentAllergen = null">
              <v-icon>add</v-icon>
            </v-btn>
          </v-layout>
          <v-layout row wrap class="views pa-3" @click="editAllergenToggle">
            <p class="m-0" v-if="allergens.length === 0">Click to add allergens</p>
            <div class="py-1 px-3 ma-0 my-1 mr-2 views--item" v-for="(allergen, index) in allergens" :key="index">
              {{allergen.name[language]}}
              <small v-if="typeof allergen.allergenId !== 'undefined'">({{ allergen.allergenId }})</small>
              <v-icon class="ml-2" @click.stop="editAllergen(allergen, index)">edit</v-icon>
              <v-icon @click.stop="deleteAllergen(allergen.allergenId)">delete</v-icon>
            </div>
          </v-layout>
          <v-layout row align-center class="mt-4 mb-2">
            <h2 class="mr-3">{{ $lang.header.massAddRemove }}</h2>
          </v-layout>
          <v-layout row wrap>
            <v-btn color="primary" @click="massAddViews = true">{{ $lang.actions.addViews1}}</v-btn>
            <v-btn color="primary" @click="massAddAllergens = true">{{ $lang.actions.addAllergens}}</v-btn>
            <v-btn color="primary" @click="massAddPrinters = true">{{ $lang.actions.addPrinters}}</v-btn>
            <v-btn color="primary" @click="massRemovePrinters = true">{{ $lang.actions.removePrinters}}</v-btn>
            <v-btn color="primary" @click="vatModal = true" :disabled="!selectedCompany || !selectedCompanyInfo.vatRates || selectedCompanyInfo.vatRates.length === 0">{{ $lang.actions.addVAT}}</v-btn>
            <v-btn color="primary" @click="massLangModal = true">{{ $lang.actions.translate}}</v-btn>
            <v-btn color="secondary" @click="exportCsv()">{{ $lang.actions.exportCSV}}</v-btn>
          </v-layout>
          <v-layout row align-center class="my-4">
            <h2 class="d-inline-block m-0">{{ $lang.header.items }}</h2>
            <v-btn fab small @click="actionPath = null; itemModal = true; currentItemEvent = 'add'" flat class="item-actions d-inline-block">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn flat class="show-buttons" @click="openAll(items, true)">{{ $lang.actions.showAllChildren}}</v-btn>
            <v-btn flat class="show-buttons" @click="openAll(items, false)">{{ $lang.actions.hideAllChildren}}</v-btn>
          </v-layout>
          <v-layout row align-center class="my-4">
          <v-flex v-if="!notLoading" text-xs-center>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-flex>
          </v-layout>
          <ul v-if="notLoading">
            <item @click.stop.prevent
              v-for="(item, index) in filtereditems"
              :key="index"
              :index="index"
              @selected="select"
              @setMaxItemId="setMaxItemId"
              @deleted="deleteItem"
              @copyItem="copyItem"
              @massAdd="massAddShow"
              @massRemove="massRemoveShow"
              @addItem="addItemEvent"
              :items="filtereditems"
              :views="views"
              :isEdit="isEdit"
              @editItem="editItemEvent"
              :itemData="item"></item>
          </ul>
          <v-layout row wrap pb-2 v-if="err || errors.length > 0 || success">
            <v-flex xs12>
            <v-alert color="error" :value="true" class="err" icon="warning" type="error" v-if="err">
              {{err}}
            </v-alert>
            <v-alert color="error" :value="true" class="err" icon="warning" type="error" v-if="errors.length > 0">
              <span v-for="err in errors">{{err.message}}.<br></span>
            </v-alert>
            <transition name="fade">
              <v-alert type="success" :value="true"  v-if="success">
                {{success}}
              </v-alert>
            </transition>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-space-between>
            <router-link class="mx-0 v-btn--flat" tag="v-btn" :to="{ path: 'list' }">
              <v-icon dark>keyboard_arrow_left</v-icon>
              cancel
            </router-link>
            <v-btn class="mx-0" color="primary" @click.stop="createCatalog" :disabled="creating">{{ $lang.actions.create }}</v-btn>
          </v-layout>
        </div>
      </v-card>
    </v-flex>
    <v-dialog v-if="itemModal" v-model="itemModal" max-width="1600px">
      <item-modal :plusOne="plusOne" :currentItemEvent="currentItemEvent" :copyData="copyItemData ? copyItemData : null" :taxCategories="taxCategories" :editItem="editItem" :actionPath="actionPath" :selectedCompanyInfo="selectedCompanyInfo" :views="views" :allergens="allergens" :maxItemId="maxItemId" :items="items" @copy="copy($event)" @submit="addItem" @close="itemModal = false;"></item-modal>
    </v-dialog>
    <v-dialog v-if="vatModal" v-model="vatModal" max-width="1200px">
      <vat-modal :selectedCompanyInfo="selectedCompanyInfo" @submit="addVATToItems" @close="vatModal = false;"></vat-modal>
    </v-dialog>
    <v-dialog v-if="massAddViews" v-model="massAddViews" max-width="1200px">
      <views-modal :views="views" @submit="addViewsToItems" @close="massAddViews = false;"></views-modal>
    </v-dialog>
    <v-dialog v-if="massAddAllergens" v-model="massAddAllergens" max-width="1200px">
      <allergens-modal :allergens="allergens" @submit="addAllergensToItems" @close="massAddAllergens = false;"></allergens-modal>
    </v-dialog>
    <v-dialog @click.stop.prevent v-if="massAddPrinters" v-model="massAddPrinters" max-width="1200px">
      <printers-modal @submit="addPrintersToItems" @close="massAddPrinters = false;"></printers-modal>
    </v-dialog>
    <v-dialog v-if="massRemovePrinters" v-model="massRemovePrinters" max-width="1200px">
      <printers-modal @submit="removePrintersFromItems" :remove="true" @close="massRemovePrinters = false;"></printers-modal>
    </v-dialog>
    <v-dialog v-if="massLangModal" v-model="massLangModal" max-width="800px">
      <lang-trans-modal @submit="massTranslate($event)" @close="massLangModal = false;"></lang-trans-modal>
    </v-dialog>
    <v-dialog v-if="editViews" v-model="editViews" max-width="700px">
      <view-modal :edit="currentView" :orderTypes="orderTypes" :selectedOrderTypes="selectedOrderTypes" :maxViewId="maxViewId" @submit="addView" @update="editViewSubmit" @changeSelectedOrderTypes="changeSelectedOrderTypes" @close="editViews = false;"></view-modal>
    </v-dialog>
    <v-dialog v-if="editAllergens" v-model="editAllergens" max-width="1200px">
      <allergen-modal :edit="currentAllergen" :maxAllergenId="maxAllergenId" @submit="addAllergen" @update="editAllergenSubmit" @close="editAllergens = false;"></allergen-modal>
    </v-dialog>
    <v-dialog v-if="showActivationModal" persistent v-model="showActivationModal" max-width="500">
      <activation-modal :data="activationData" @close="closeActivation()"/>
    </v-dialog>
    <v-dialog v-if="massRemoveViews" persistent v-model="massRemoveViews" max-width="500">
      <confirmation-modal :text="$lang.labels.massRemoveViews" @submit="removeViewFromItems()" @close="massRemoveViews = false;"/>
    </v-dialog>
    <v-dialog v-if="massRemoveAllergens" persistent v-model="massRemoveAllergens" max-width="500">
      <confirmation-modal :text="$lang.labels.massRemoveAllergens" @submit="removeAllergenFromItems()" @close="massRemoveAllergens = false;"/>
    </v-dialog>
    <transition name="fade">
      <v-dialog v-if="massAddModal" persistent v-model="massAddModal" max-width="800">
        <mass-add-modal :catalog="items" :data="massAddData" :views="views" :taxCategories="taxCategories" :selectedCompanyInfo="selectedCompanyInfo" @submit="massAdd($event)" @close="massAddModal = false"/>
      </v-dialog>
    </transition>
    <transition name="fade">
      <v-dialog v-if="massRemoveModalTree" persistent v-model="massRemoveModalTree" max-width="800">
        <mass-remove-modal :data="massRemoveDataTree" :viewsTree="viewsTree" :printCategoriesTree="printCategoriesTree" :views="views" :taxCategories="taxCategories" :selectedCompanyInfo="selectedCompanyInfo" @submit="massRemove($event)" @close="massRemoveModalTree = false"/>
      </v-dialog>
    </transition>
    <transition name="fade">
      <v-dialog v-if="predefinedViewsModal" v-model="predefinedViewsModal" max-width="800">
        <add-predefined-views :filteredViews="filteredViews" @submit="addPredefinedView($event)" @close="predefinedViewsModal = false"/>
      </v-dialog>
    </transition>
    <div
      v-show="show"
      class="overlay"
      @click="show = false"/>
  </v-layout>
</template>

<script>
  import Vue from 'vue';
  import * as fetch_data from '../../assets/fetch_data';
  import {baseUrl} from '../../assets/url';
  import _ from 'lodash';
  import {allergensData} from '../../assets/allergens';
  import copy from 'copy-to-clipboard'
  function searchMaxId(item){
    const itemId = item.itemId || 0;
    if(!item.items || item.items.length <= 0){
      return itemId;
    } else {
      const items = item.items;
      let index = items.length;
      let _maxId = 0;
      while(index--){
        const result = searchMaxId(items[index]);
        if(result > _maxId){
          _maxId = result;
        }
      }
      return itemId > _maxId ? itemId: _maxId;
    }
  }
  export default {
    data() {
      return {
        notLoading: true,
        err: '',
        errors: [],
        isLocalAdmin: false,
        currentItemEvent: '',
        creating: false,
        success: '',
        name: '',
        version: null,
        openCompanies: false,
        filter: '',
        items: [],
        views: [],
        parsedItemList: [],
        companies: [],
        selectedCompany: null,
        selectedCompanyInfo: {},
        initToggle: true,
        currentView: null,
        plusOne: false,
        itemModal: false,
        editViews: false,
        massAddViews: false,
        massAddPrinters: false,
        massRemovePrinters: false,
        massLangModal: false,
        massRemoveViews: false,
        vatModal: false,
        selectedItem: null,
        actionPath: null,
        pickedItem: null,
        language: this.$cookie.get('lang') || 'en',
        itemsIds: [],
        isCatalogValid: false,
        viewsIds: [],
        notUniqItemsIds: [],
        loaded: false,
        allCorporations: [],
        currentCorporation: null,
        showActivationModal: false,
        activationData: null,
        isEdit: null,
        show: false,
        copyItemData: null,
        taxCategories: [],
        massAddModal: false,
        massAddData: null,
        massRemoveModalTree: false,
        massRemoveDataTree: null,
        viewsTree: [],
        printCategoriesTree: [],
        allergens: [],
        allergensIds: [],
        currentAllergen: null,
        editAllergens: false,
        massAddAllergens: false,
        massRemoveAllergens: false,
        orderTypes: null,
        selectedOrderTypes: [],
        predefinedViews: [
          {"name":{"en":"Collection","de":"Collection"}, "orderTypes": ['collection']},
          {"name":{"en":"Webshop","de":"Webshop"}, "orderTypes": ['delivery']},
          {"name":{"en":"Takeaway","de":"Takeaway"}, "orderTypes": ['takeaway']},
          {"name":{"en":"Restaurant","de":"Restaurant"}, "orderTypes": ['restaurant']},
          {"name":{"en":"Self-service","de":"Self-service"}, "orderTypes": []},
          {"name":{"en":"Simple-inventory","de":"Simple-inventory"}, "orderTypes": []},
          {"name":{"en":"Full-inventory","de":"Full-inventory"}, "orderTypes": []},
        ],
        predefinedViewsModal: false,
        isPasteOn: false
      };
    },
    watch:{
      selectedCompany: {
        handler(val) {
          if (!val) return;
          this.fetchCompany();
        },
        immediate: true,
        deep: true,
      }
    },
    computed: {
      maxItemId() {
        let val = 0;
        const items = this.items;
        let index = items.length;

        while(index--){
          const result = searchMaxId(items[index]);
          if(val < result){
            val = result;
          }
        }
        return val;
      },
      maxViewId() {
        let val = 0;
        const views = this.views;
        let index = views.length;
        while(index--){
          let result = views[index].viewId;
          if(val < result){
            val = result;
          }
        }
        return val;
      },
      maxAllergenId() {
        let val = 0;
        const allergens = this.allergens;
        let index = allergens.length;
        while(index--){
          let result = allergens[index].allergenId;
          if(val < result){
            val = result;
          }
        }
        return val;
      },
      allowedCompanies() {
        return this.currentCorporation ?
          this.companies.filter(company => this.currentCorporation.companies.includes(company.id)) :
          this.companies;
      },
      filteredCompanies() {
        return this.filter.length === 0 ? this.allowedCompanies : this.allowedCompanies.filter(company =>
          company.name.toLowerCase().includes(this.filter.toLowerCase()));
      },
      filteredViews() {
        const addedViews = this.views.map(x => x.name.en);
        return this.predefinedViews.filter(y => !addedViews.includes(y.name.en));
      },
      filtereditems() {
        return this.items;
      },
    },
    methods: {
      turnOnPasteListen() {
        if (this.isPasteOn) {
          this.isPasteOn = false;
          document.removeEventListener('paste', this.pasteWholeCatalog);
          this.success = 'Not listening to Paste event'
          setTimeout(() => this.success = '', 6000)
        } else {
          this.isPasteOn = true;
          document.addEventListener('paste', this.pasteWholeCatalog);
          this.success = 'Listening to Paste event'
          setTimeout(() => this.success = '', 6000)
        }
      },
      copyWholeCatalog() {
        const copyData = this.$data;
        delete copyData.selectedCompany;
        delete copyData.selectedCompanyInfo;
        copy(JSON.stringify(copyData));
        this.success = 'Catalog copied to memory'
        setTimeout(() => this.success = '', 6000)
      },
      pasteWholeCatalog(event) {
        if (this.isPasteOn) {
          const clipboardData = event.clipboardData || event.originalEvent.clipboardData || window.clipboardData;
          const replacedData = clipboardData.getData('text');

          const replacedSectionParsed = replacedData ? JSON.parse(replacedData) : {};
          for (const row in replacedSectionParsed) {
            // eslint-disable-next-line no-prototype-builtins
            if (replacedSectionParsed.hasOwnProperty(row)) {
              this[row] = replacedSectionParsed[row]
            }
          }
        }
      },
      addPredefinedView(view) {
        this.views.push({viewId: this.maxViewId + 1, ...view, isDefault: false});
        this.predefinedViewsModal = false;
      },
      formattedViews(itemData) {
        return this.views && this.views.length !== 0 && itemData.views.length !== 0 ? itemData.views
          .map(current => this.views.find(view => view.viewId === current).name[this.language])
          .join(', ') : 'none';
      },
      formattedPrintCategories(itemData) {
        return itemData.printerCategories && itemData.printerCategories.length > 0 ?
          itemData.printerCategories.join(', ') :
          'none';
      },
      formattedSettings(itemData) {
        let settings = [];
        if (itemData.settings) {
          if (itemData.settings.labelPrint) {
            settings.push('Label print');
          }
          if (itemData.settings.askDetails) {
            settings.push('Ask details');
          }
        }
        if (itemData.vatPrint) {
          settings.push('VAT print');
        }
        if (itemData.noDiscount) {
          settings.push('No Discount');
        }
        if (itemData.galaxyCardBalance) {
          settings.push('Galaxy Card Balance');
        }
        return settings.join(', ');
      },
      addVATToItems(vat) {
        this.vatModal = false;
        const addVat = (selectedVat, items) => {
          items.forEach((item) => {
            this.$set(item, 'vatRate', selectedVat);
            if (item.items) {
              addVat(selectedVat, item.items);
            }
          });
        };
        addVat(vat, this.items);
      },
      removeViewFromItems() {
        this.massRemoveViews = false;
        const removeView = (view, items) => {
          items.forEach((item) => {
            const currentViews = item.views;
            if (!currentViews) return;
            const currentIndex = currentViews.indexOf(view);
            if (currentIndex !== -1) {
              currentViews.splice(currentIndex, 1);
            }
            this.$set(item, 'views', currentViews);
            if (item.items) {
              removeView(view, item.items);
            }
          });
        };
        removeView(this.selectedView, this.items);
        this.views = this.views.filter(view => view.viewId !== this.selectedView);
        this.viewsIds = this.viewsIds.filter(view => view !== this.selectedView);
        this.selectedView = null;
      },
      addViewsToItems(views) {
        this.massAddViews = false;
        const addViews = (selectedViews, items) => {
          items.forEach((item) => {
            const currentViews = item.views;
            const addedViews = [];
            if (!currentViews) {
              this.$set(item, 'views', selectedViews);
            } else {
              addedViews.push(...currentViews);
              selectedViews.forEach((view) => {
                if (!addedViews.includes(view)) {
                  addedViews.push(view);
                }
              });
              this.$set(item, 'views', addedViews);
            }
            if (item.items) {
              addViews(selectedViews, item.items);
            }
          });
        };
        addViews(views, this.items);
      },
      removeAllergenFromItems(){
        this.massRemoveAllergens = false;
        const removeAllergen = (allergen, items) => {
          items.forEach((item) => {
            const currentAllergens = item.allergens;
            if (!currentAllergens) return;
            const currentIndex = currentAllergens.indexOf(allergen);
            if (currentIndex !== -1) {
              currentAllergens.splice(currentIndex, 1);
            }
            this.$set(item, 'allergens', currentAllergens);
            if (item.items) {
              removeAllergen(allergen, item.items);
            }
          });
        };
        removeAllergen(this.selectedAllergen, this.items);
        this.allergens = this.allergens.filter(allergen => allergen.allergenId !== this.selectedAllergen);
        this.allergensIds = this.allergensIds.filter(allergen => allergen !== this.selectedAllergen);
        this.selectedAllergen = null;
      },
      addAllergensToItems(allergens) {
        this.massAddAllergens = false;
        const addAllergens = (selectedAllergens, items) => {
          items.forEach((item) => {
            const currentAllergens = item.allergens;
            const addedAllergens = [];
            if (!currentAllergens) {
              this.$set(item, 'allergens', selectedAllergens);
            } else {
              addedAllergens.push(...currentAllergens);
              selectedAllergens.forEach((allergen) => {
                if (!addedAllergens.includes(allergen)) {
                  addedAllergens.push(allergen);
                }
              });
              this.$set(item, 'allergens', addedAllergens);
            }
            if (item.items) {
              addAllergens(selectedAllergens, item.items);
            }
          });
        };
        addAllergens(allergens, this.items);
      },
      addPrintersToItems(printers) {
        this.massAddPrinters = false;
        const addPrinters = (selectedPrinters, items) => {
          items.forEach((item) => {
            const currentPrinters = item.printerCategories;
            const addedPrinters = [];
            if (!currentPrinters) {
              Vue.set(item, 'printerCategories', selectedPrinters);
            } else {
              addedPrinters.push(...currentPrinters);
              selectedPrinters.forEach((view) => {
                if (!addedPrinters.includes(view)) {
                  addedPrinters.push(view);
                }
              });
              Vue.set(item, 'printerCategories', addedPrinters);
            }
            if (item.items) {
              addPrinters(selectedPrinters, item.items);
            }
          });
        };
        addPrinters(printers, this.items);
      },
      massTranslate(data) {
        this.massLangModal = false;
        const massTrans = (transData, items) => {
            items.forEach((item) => {
              if (item.name && item.name[transData.inputLang]) {
                if (item.name[transData.outputLang] && transData.scope[1].selected) {
                  item.name[transData.outputLang] = item.name[transData.inputLang];
                } else if (!item.name[transData.outputLang]) {
                  item.name[transData.outputLang] = item.name[transData.inputLang];
                }
              }

              if (item.abbr && item.abbr[transData.inputLang]) {
                if (item.abbr[transData.outputLang] && transData.scope[0].selected) {
                  item.abbr[transData.outputLang] = item.abbr[transData.inputLang];
                } else if (!item.abbr[transData.outputLang]) {
                  item.abbr[transData.outputLang] = item.abbr[transData.inputLang];
                }
              }

              if (item.desc && item.desc[transData.inputLang]) {
                if (item.desc[transData.outputLang] && transData.scope[2].selected) {
                  item.desc[transData.outputLang] = item.desc[transData.inputLang];
                } else if (!item.desc[transData.outputLang]) {
                  item.desc[transData.outputLang] = item.desc[transData.inputLang];
                }
              }

              if (item.sizes) {
                item.sizes.forEach((size) => {
                  if (size.name && size.name[transData.inputLang]) {
                    if (size.name[transData.outputLang] && transData.scope[3].selected) {
                      size.name[transData.outputLang] = size.name[transData.inputLang];
                    } else if (!size.name[transData.outputLang]) {
                      size.name[transData.outputLang] = size.name[transData.inputLang];
                    }
                  }
                });
              }

              if (item.options) {
                item.options.forEach((option) => {
                  if (option.name && option.name[transData.inputLang]) {
                    if (option.name[transData.outputLang] && transData.scope[4].selected) {
                      option.name[transData.outputLang] = option.name[transData.inputLang];
                    } else if (!option.name[transData.outputLang]) {
                      option.name[transData.outputLang] = option.name[transData.inputLang];
                    }
                  }
                });
              }

              if (item.variants) {
                item.variants.forEach((variant) => {
                  if (variant.name && variant.name[transData.inputLang]) {
                    if (variant.name[transData.outputLang] && transData.scope[5].selected) {
                      variant.name[transData.outputLang] = variant.name[transData.inputLang];
                    } else if (!variant.name[transData.outputLang]) {
                      variant.name[transData.outputLang] = variant.name[transData.inputLang];
                    }
                  }
                });
              }

              if (item.styles) {
                item.styles.forEach((style) => {
                  if (style.name && style.name[transData.inputLang]) {
                    if (style.name[transData.outputLang] && transData.scope[6].selected) {
                      style.name[transData.outputLang] = style.name[transData.inputLang];
                    } else if (!style.name[transData.outputLang]) {
                      style.name[transData.outputLang] = style.name[transData.inputLang];
                    }
                  }
                });
              }
              if (item.items) {
                massTrans(data, item.items);
              }
            });
        };
        massTrans(data, this.items);
      },
      removePrintersFromItems(printers) {
        this.massRemovePrinters = false;
        const removePrinters = (selectedPrinters, items) => {
          items.forEach((item) => {
            if (item.printerCategories) {
              const currentPrinters = item.printerCategories.slice();
              selectedPrinters.forEach((printer) => {
                const found = currentPrinters.findIndex(current => current === printer);
                if (found !== -1) {
                  currentPrinters.splice(found, 1);
                }
              });
              Vue.set(item, 'printerCategories', currentPrinters);
            }
            if (item.items) {
              removePrinters(selectedPrinters, item.items);
            }
          });
        };
        removePrinters(printers, this.items);
      },
      selectCompany(company) {
        this.openCompanies = false;
        this.filter = '';
        this.selectedCompany = company;
        this.show = false;
      },
      setMaxItemId(val){
        if(this.maxItemId < val){
          this.maxItemId = val;
        }
      },
      addItemEvent(event) {
        this.currentItemEvent = 'add';
        this.actionPath = event[0];
        this.plusOne = event[1];
        this.itemModal = true;
      },
      editItemEvent(event) {
        this.currentItemEvent = 'edit';
        this.actionPath = event[0];
        this.plusOne = event[1];
        this.itemModal = true;
      },
      addAllergen(event) {
        this.allergens.push(event);
        // this.viewsIds.push(event.viewId);
      },
      editAllergenToggle() {
        if (this.allergens.length > 0) return;
        this.editAllergen = true;
      },
      editAllergen(allergen, index) {
        this.currentAllergen = {
          allergen,
          index,
        };
        this.editAllergens = true;
      },
      editAllergenSubmit(event) {
        this.allergens[event.index] = event.allergen;
      },
      deleteAllergen(allergenId) {
        this.selectedAllergen = allergenId;
        this.massRemoveAllergens = true;
      },

      addView(event) {
        this.views.push(event);
        this.selectedOrderTypes.push(...event.orderTypes);
        // this.viewsIds.push(event.viewId);
      },
      editViewToggle() {
        if (this.views.length > 0) return;
        this.editViews = true;
      },
      editView(view, index) {
        this.currentView = {
          view,
          index,
        };
        this.editViews = true;
      },
      editViewSubmit(event) {
        this.views = this.views.map(view => ({
          ...view,
          isDefault: false
        }));
        this.views[event.index] = event.view;
        this.selectedOrderTypes.push(...event.view.orderTypes);
      },
      changeSelectedOrderTypes(event) {
        const tempIndex = this.selectedOrderTypes.indexOf(event);
        if (tempIndex === -1) this.selectedOrderTypes.push(event);
        if (tempIndex > -1) this.selectedOrderTypes.splice(tempIndex, 1);
      },
      deleteView(viewId) {
        this.selectedView = viewId;
        this.massRemoveViews = true;
      },
      addItem(event, itemData) {
        this.taxCategories.push(event.taxCategory);
        this.taxCategories = this.taxCategories.filter( this.onlyUnique );
        if(this.currentItemEvent === 'edit'){
          this.editItem(event);
          return;
        }
        if(this.currentItemEvent === 'add'){
          this.itemsIds.push(event.itemId);
        }
        if (this.actionPath !== null) {
          this.addItemToChild({ ...event, open: true });
          return;
        }
        const goDeeper = (item, indexes) => {
          if (indexes.length > 0) {
            const postition = indexes.length - 1;
            const index = indexes[postition];
            indexes.splice(postition, 1);
            const target = indexes.length === 0 ? item[index] : item[index].items;
            return goDeeper(target, indexes);
          }
          return item;
        };
        if (this.selectedItem === null) {
          this.items.push({ ...event, open: true });
        } else {
          const indexes = this.selectedItem;
          const item = goDeeper(this.items, indexes);
          if (item.items) {
            const items = item.items;
            items.push({ ...event, open: true });
            Vue.set(item, 'items', items);
          } else {
            Vue.set(item, 'items', [{ ...event, open: true }]);
          }
        }
      },
      editItem(event){
        return;
      },
      addItemToChild(event) {
        this.select(this.actionPath);
        const addToTarget = (target, list, item) => {
          if (list.length === 0) {
            if (!target.items) {
              Vue.set(target, 'items', [item]);
            } else {
              const items = target.items;
              items.push(item);
              Vue.set(target, 'items', items);
            }
            return true;
          }
          const position = list.length - 1;
          const index = list[position];
          list.splice(position, 1);
          const newTarget = target.items[index];
          return addToTarget(newTarget, list, item);
        };
        const position = this.actionPath.length - 1;
        const current = this.actionPath[position];
        this.actionPath.splice(position, 1);
        addToTarget(this.items[current], this.actionPath, event);
        this.actionPath = null;
      },
      deselectSiblings(target, list, select) {
        if (this.initToggle) {
          Vue.set(target, 'selected', true);
        }
        if (list.length === 1) {
          const position = list[0];
          const deselected = target.items.map((current, index) => {
            const item = current;
            if (select) {
              item.selected = position === index;
              return item;
            }
            item.selected = false;
            return item;
          });
          Vue.set(target, 'items', deselected);
          return true;
        }
        const position = list.length - 1;
        const index = list[position];
        list.splice(position, 1);
        const newTarget = target.items[index];
        return this.deselectSiblings(newTarget, list, select);
      },
      deselectAll(items = this.items, value = false) {
        items.forEach(item => {
          this.$set(item, 'selected', value);
          if (item.items) this.deselectAll(item.items, value);
        });
      },
      openAll(items = this.items, value = false) {
        items.forEach(item => {
          this.$set(item, 'open', value);
          if (item.items) this.openAll(item.items, value);
        });
      },
      select(event) {
        let data;
        this.deselectAll();
        let eventFiltered = null;
        if (typeof event[1] === 'boolean') {
          eventFiltered = event[0];
        } else {
          eventFiltered = event;
        }
        if (!eventFiltered.path) {
          data = {
            path: JSON.parse(JSON.stringify(eventFiltered)),
            select: true,
          };
        } else {
          data = JSON.parse(JSON.stringify(eventFiltered));
        }
        this.selectedItem = data.path;
        if (data.path.length === 1) {
          this.items = this.items.map((current, index) => {
            const item = current;
            item.selected = index === data.path[0];
            return item;
          });
        } else {
          const position = this.selectedItem.length - 1;
          const current = this.selectedItem[position];
          this.selectedItem.splice(position, 1);
          this.deselectSiblings(this.items[current], this.selectedItem, data.select);
        }
        this.selectedItem = null;
      },
      copy(event) {
        delete event['itemId'];
        this.copyItemData = event;
        localStorage.copyItemData = JSON.stringify(event);
      },
      copyItem(event) {
        event[0].reverse();
        if (event[0].length === 1) {
          let tempItem = JSON.parse(JSON.stringify(this.items[event[0][0]]));
          if (tempItem.items) {
            delete tempItem['items'];
          }
          tempItem.itemId = this.maxItemId + 1;
          this.items.push(tempItem);
        } else {
          let parent = this.items;
          let child = {};
          for (let i = 0; i < event[0].length; i += 1) {
            if (i !== event[0].length - 1) {
              parent = parent[event[0][i]].items;
            } else {
              child = parent[event[0][i]];
            }
          }
          let tempChild = JSON.parse(JSON.stringify(child));
          tempChild.itemId = this.maxItemId + 1;
          if (tempChild.items) {
            delete tempChild['items'];
          }
          parent.push(tempChild);
        }
      },
      massRemoveShow(event) {
        this.massRemoveDataTree = event[0];
        this.massRemoveDataTree.reverse();
        let startItem = this.items[this.massRemoveDataTree[0]];
        if (this.massRemoveDataTree.length > 1) {
          for (let i = 1; i < this.massRemoveDataTree.length; i += 1) {
            startItem = startItem.items[this.massRemoveDataTree[i]];
          }
        }
        let viewsInTree = [];
        let printCategoriesInTree = [];
        viewsInTree.push(startItem.views);
        printCategoriesInTree.push(startItem.printerCategories);
        const addChildrenProperties = (items) => {
          items.forEach(item => {
            viewsInTree.push(item.views);
            printCategoriesInTree.push(item.printerCategories);
            if (item.items && item.items.length > 0) {
              addChildrenProperties(item.items);
            }
          });
        };
        if (startItem.items && startItem.items.length > 0) addChildrenProperties(startItem.items);
        viewsInTree = viewsInTree.flat(Infinity).filter( this.onlyUnique );
        printCategoriesInTree = printCategoriesInTree.flat(Infinity).filter( this.onlyUnique );
        this.viewsTree = viewsInTree;
        this.printCategoriesTree = printCategoriesInTree;
        this.massRemoveModalTree = true;
      },
      massRemove(event) {
        let startItem = this.items[event.item[0]];
        if (event.item.length > 1) {
          for (let i = 1; i < event.item.length; i += 1) {
            startItem = startItem.items[event.item[i]];
          }
        }
        if (event.type === 'views' || event.type === 'printerCategories') {
          startItem[event.type] = startItem[event.type].filter(x => !event.value.includes(x));
        }
        if (startItem.items) {
          const massUpdateChildren = (items) => {
            items.forEach((item) => {
              if (event.type === 'views' || event.type === 'printerCategories') {
                item[event.type] = item[event.type].filter(x => !event.value.includes(x));
              }
              if (item.items && item.items.length > 0) {
                massUpdateChildren(item.items);
              }
            });
          };
          massUpdateChildren(startItem.items);
        }
        this.massRemoveDataTree = null;
        this.massRemoveModalTree = false;
      },
      massAddShow(event) {
        this.massAddData = event[0];
        this.massAddModal = true;
      },
      formatAddItemsChildren(id) {
        let found = null;
        const findItem = (items) => {
          items.forEach((item) => {
            if (item.itemId === id) found = JSON.parse(JSON.stringify(item));
            if (item.items && item.items.length > 0 && !found) {
              findItem(item.items);
            }
          });
        };
        findItem(this.items);
        if (found && found.items && found.items.length > 0) {
          let tempMaxId = this.maxItemId;
          const loopItems = (items) => {
            items.forEach((item) => {
              item.itemId = tempMaxId + 1;
              tempMaxId += 1;
              if (item.items && item.items.length > 0 && !found) {
                loopItems(item.items);
              }
            });
          };
          loopItems(found.items);
          return found.items;
        } else {
          return [];
        }
      },
      massAdd(event) {
        event.item.reverse();
        let startItem = this.items[event.item[0]];
        if (event.item.length > 1) {
          for (let i = 1; i < event.item.length; i += 1) {
            startItem = startItem.items[event.item[i]];
          }
        }
        if (event.type === 'views') {
          startItem[event.type] = startItem[event.type].concat(event.value);
          startItem[event.type] = startItem[event.type].filter( this.onlyUnique );
        } else if (event.type === 'printerCategories') {
          startItem[event.type] = startItem[event.type].concat(event.value);
          startItem[event.type] = startItem[event.type].filter( this.onlyUnique );
        } else if (event.type === 'settings' && event.value.length > 0) {
          event.value.forEach(property => {
            if (property === 'labelPrint') {
              startItem.settings.labelPrint = true;
            }
            if (property === 'askDetails') {
              startItem.settings.askDetails = true;
            }
            if (property === 'vatPrint') {
              startItem.vatPrint = true;
            }
            if (property === 'noDiscount') {
              startItem.noDiscount = true;
            }
            if (property === 'galaxyCardBalance') {
              startItem.galaxyCardBalance = true;
            }
          })
        } else if (event.type === 'sizes') {
          const obj = {
            isDefault: event.value.isDefault,
            price: Number(event.value.price),
            name: {}
          };
          if (event.value.en) obj.name.en = event.value.en;
          if (event.value.de) obj.name.de = event.value.de;
          if (event.value.zh) obj.name.zh = event.value.zh;
          if (startItem[event.type] && startItem[event.type].length > 0) {
            let isThere = false;
            startItem[event.type].forEach(current => {
              if (obj.isDefault) current.isDefault = false;
              if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                current = obj;
                isThere = true;
              }
            });
            if (!isThere) {
              if (startItem[event.type]) {
                startItem[event.type].push(obj);
              } else {
                startItem[event.type] = obj;
              }
            }
          } else {
            startItem[event.type] = [obj];
          }
        } else if (event.type === 'variants') {
          const obj = {
            isDefault: event.value.isDefault,
            price: Number(event.value.price),
            name: {}
          };
          if (event.value.en) obj.name.en = event.value.en;
          if (event.value.de) obj.name.de = event.value.de;
          if (event.value.zh) obj.name.zh = event.value.zh;
          if (startItem[event.type] && startItem[event.type].length > 0) {
            let isThere = false;
            startItem[event.type].forEach(current => {
              if (obj.isDefault) current.isDefault = false;
              if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                current = obj;
                isThere = true;
              }
            });
            if (!isThere) {
              if (startItem[event.type]) {
                startItem[event.type].push(obj);
              } else {
                startItem[event.type] = obj;
              }
            }
          } else {
            startItem[event.type] = [obj];
          }
        } else if (event.type === 'options') {
          const obj = {
            isDefault: event.value.isDefault,
            price: Number(event.value.price),
            name: {}
          };
          if (event.value.en) obj.name.en = event.value.en;
          if (event.value.de) obj.name.de = event.value.de;
          if (event.value.zh) obj.name.zh = event.value.zh;
          if (startItem[event.type] && startItem[event.type].length > 0) {
            let isThere = false;
            startItem[event.type].forEach(current => {
              if (obj.isDefault) current.isDefault = false;
              if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                current = obj;
                isThere = true;
              }
            });
            if (!isThere) {
              if (startItem[event.type]) {
                startItem[event.type].push(obj);
              } else {
                startItem[event.type] = obj;
              }
            }
          } else {
            startItem[event.type] = [obj];
          }
        } else if (event.type === 'styles') {
          const obj = {
            isDefault: event.value.isDefault,
            name: {}
          };
          if (event.value.en) obj.name.en = event.value.en;
          if (event.value.de) obj.name.de = event.value.de;
          if (event.value.zh) obj.name.zh = event.value.zh;
          if (startItem[event.type] && startItem[event.type].length > 0) {
            let isThere = false;
            startItem[event.type].forEach(current => {
              if (obj.isDefault) current.isDefault = false;
              if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                current = obj;
                isThere = true;
              }
            });
            if (!isThere) {
              if (startItem[event.type]) {
                startItem[event.type].push(obj);
              } else {
                startItem[event.type] = obj;
              }
            }
          } else {
            startItem[event.type] = [obj];
          }
        } else if (event.type === 'items') {
          const itemsFormatted = this.formatAddItemsChildren(event.value);
          if (startItem.items) {
            startItem.items = [...startItem.items, ...itemsFormatted];
          } else {
            startItem.items = itemsFormatted;
          }
          this.notLoading = false;
          this.items = JSON.parse(JSON.stringify(this.items));
          setTimeout(()=> {
            this.notLoading = true;
          }, 500)
        } else {
          startItem[event.type] = event.value;
        }
        if (startItem.items && event.type !== 'items') {
          const massUpdateChildren = (items) => {
            items.forEach((item) => {
              if (event.type === 'views') {
                item[event.type] = item[event.type].concat(event.value);
                item[event.type] = item[event.type].filter( this.onlyUnique );
              } else if (event.type === 'printerCategories') {
                item[event.type] = item[event.type].concat(event.value);
                item[event.type] = item[event.type].filter( this.onlyUnique );
              } else if (event.type === 'settings' && event.value.length > 0) {
                event.value.forEach(property => {
                  if (property === 'labelPrint') {
                    item.settings.labelPrint = true;
                  }
                  if (property === 'askDetails') {
                    item.settings.askDetails = true;
                  }
                  if (property === 'vatPrint') {
                    item.vatPrint = true;
                  }
                  if (property === 'noDiscount') {
                    item.noDiscount = true;
                  }
                  if (property === 'galaxyCardBalance') {
                    item.galaxyCardBalance = true;
                  }
                })
              } else if (event.type === 'sizes') {
                const obj = {
                  isDefault: event.value.isDefault,
                  price: Number(event.value.price),
                  name: {}
                };
                if (event.value.en) obj.name.en = event.value.en;
                if (event.value.de) obj.name.de = event.value.de;
                if (event.value.zh) obj.name.zh = event.value.zh;
                if (item[event.type] && item[event.type].length > 0) {
                  let isThere = false;
                  item[event.type].forEach(current => {
                    if (obj.isDefault) current.isDefault = false;
                    if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                      current = obj;
                      isThere = true;
                    }
                  });
                  if (!isThere) {
                    if (item[event.type]) {
                      item[event.type].push(obj);
                    } else {
                      item[event.type] = obj;
                    }
                  }
                } else {
                  item[event.type] = [obj];
                }
              } else if (event.type === 'variants') {
                const obj = {
                  isDefault: event.value.isDefault,
                  price: Number(event.value.price),
                  name: {}
                };
                if (event.value.en) obj.name.en = event.value.en;
                if (event.value.de) obj.name.de = event.value.de;
                if (event.value.zh) obj.name.zh = event.value.zh;
                if (item[event.type] && item[event.type].length > 0) {
                  let isThere = false;
                  item[event.type].forEach(current => {
                    if (obj.isDefault) current.isDefault = false;
                    if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                      current = obj;
                      isThere = true;
                    }
                  });
                  if (!isThere) {
                    if (item[event.type]) {
                      item[event.type].push(obj);
                    } else {
                      item[event.type] = obj;
                    }
                  }
                } else {
                  item[event.type] = [obj];
                }
              } else if (event.type === 'options') {
                const obj = {
                  isDefault: event.value.isDefault,
                  price: Number(event.value.price),
                  name: {}
                };
                if (event.value.en) obj.name.en = event.value.en;
                if (event.value.de) obj.name.de = event.value.de;
                if (event.value.zh) obj.name.zh = event.value.zh;
                if (item[event.type] && item[event.type].length > 0) {
                  let isThere = false;
                  item[event.type].forEach(current => {
                    if (obj.isDefault) current.isDefault = false;
                    if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                      current = obj;
                      isThere = true;
                    }
                  });
                  if (!isThere) {
                    if (item[event.type]) {
                      item[event.type].push(obj);
                    } else {
                      item[event.type] = obj;
                    }
                  }
                } else {
                  item[event.type] = [obj];
                }
              } else if (event.type === 'styles') {
                const obj = {
                  isDefault: event.value.isDefault,
                  name: {}
                };
                if (event.value.en) obj.name.en = event.value.en;
                if (event.value.de) obj.name.de = event.value.de;
                if (event.value.zh) obj.name.zh = event.value.zh;
                if (item[event.type] && item[event.type].length > 0) {
                  let isThere = false;
                  item[event.type].forEach(current => {
                    if (obj.isDefault) current.isDefault = false;
                    if (current.name[this.selectedCompanyInfo.defaultLanguage] === obj.name[this.selectedCompanyInfo.defaultLanguage]) {
                      current = obj;
                      isThere = true;
                    }
                  });
                  if (!isThere) {
                    if (item[event.type]) {
                      item[event.type].push(obj);
                    } else {
                      item[event.type] = obj;
                    }
                  }
                } else {
                  item[event.type] = [obj];
                }
              } else {
                item[event.type] = event.value;
              }
              if (item.items) {
                massUpdateChildren(item.items);
              }
            });
          };
          massUpdateChildren(startItem.items);
        }
        this.massAddData = null;
        this.massAddModal = false;
      },
      exportCsv() {
        let csvContent = "data:text/csv;charset=utf-8,";
        let howDeep = 0;
        const buildCsv = (items) => {
          items.forEach((item, index) => {
            if (howDeep !== 0) {
              for (let i = 0; i < howDeep; i += 1) {
                csvContent += ';'
              }
            }
            csvContent += (item.name[this.$cookie.get('lang')] || item.name['en']) + '(' + item.itemId + ')' + '  -  ' + 'Views:' + this.formattedViews(item) + '  -  ' + 'Printer categories:' + this.formattedPrintCategories(item) + '  -  ' + 'Settings:' + this.formattedSettings(item) + '  -  ' + 'Tax category:' + item.taxCategory + "\n";
            if (item.items) {
              howDeep += 1;
              buildCsv(item.items);
            }
            if (index === items.length -1) {
              howDeep -= 1;
            }
          });
        };

        buildCsv(this.items);

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "export.csv");
        link.click();
      },
      deleteItem(event) {
        const removeChildrenIDs = (item) => {
          item.items.forEach(cItem => {
            if (cItem.items && cItem.items.length > 0) removeChildrenIDs(cItem);
            this.itemsIds = this.itemsIds.filter((id) => id !== cItem.itemId);
          })
        };
        const deleteItem = (target, list) => {
          if (list.length === 1) {
            const position = list[0];
            const deleted = target.items.filter((item, index) => {
              if (index !== position) return item;
              if (item.items && item.items.length > 0) removeChildrenIDs(item);
              this.itemsIds = this.itemsIds.filter((id) => id !== item.itemId);
              return false;
            });
            Vue.set(target, 'items', deleted);
            return true;
          }
          const position = list.length - 1;
          const index = list[position];
          list.splice(position, 1);
          const newTarget = target.items[index];
          return deleteItem(newTarget, list);
        };
        if (event[0].length === 1) {
          this.items = this.items.filter((item, index) => {
            if (index !== event[0][0]) return item;
            if (item.items && item.items.length > 0) removeChildrenIDs(item);
            this.itemsIds = this.itemsIds.filter((id) => id !== item.itemId);
            return false;
          });
        } else {
          const position = event[0].length - 1;
          const current = event[0][position];
          event[0].splice(position, 1);
          deleteItem(this.items[current], event[0]);
        }
      },
      async setIsDefault(items) {
        items.forEach((item) => {
          ['styles', 'variants', 'sizes', 'options'].forEach((key) => {
            if (key === 'options' && item[key] && item[key].length > 0) {
              item[key].forEach((opt) => {
                if (!opt.isDefault) this.$set(opt, 'isDefault', false);
                if (opt.maxIncludedQuantity === undefined) {
                  this.$set(opt, 'maxIncludedQuantity', 0);
                }
              });
            } else if (key === 'options' && item[key] && item[key].length === 0) {
              delete item['options'];
            }
            if (item[key] && item[key].length === 1) {
              this.$set(item[key][0], 'isDefault', true);
            }
          });
          if (!item.taxCategory) {
            item.taxCategory = 'none';
          }
          if (item.items) {
            this.setIsDefault(item.items);
          }
          if (!item.quantityOfIncludedOptions) {
            item.quantityOfIncludedOptions = 0;
          }
          if (!item.courseNo) {
            item.courseNo = 6;
          }
        });
      },
      async prepareImages(items) {
        for (const item of items) {
          if (!item.images || item.images.length === 0) delete item['images'];
          if (item.images) {
            item.images.map((image) => {
              delete image["name"];
              delete image["status"];
              delete image["createdOn"];
              delete image["createdBy"];
              delete image["modifiedOn"];
              delete image["modifiedBy"];
              delete image["base64Image"];
              delete image["companyId"];
              if (image.id) {
                image['value'] = image['id'];
                delete image["id"];
              }
              return image;
            });
          }
          if (item.items) {
            await this.prepareImages(item.items);
          }
        }
      },
      async createCatalog() {
        // if(this.currentCompany === 'add'){
        //   this.viewsIds = this.views.map((view)=>view.viewId)
        // }
        await this.removeErrors();
        this.validateBeforeCreateNewCatalog();
        await this.setIsDefault(this.items);
        await this.prepareImages(this.items);
        if(!this.isCatalogValid){
          return;
        }
        this.creating = true;
        let data = {
          companyId: this.selectedCompany.id,
          lastItemId: this.maxItemId,
          lastViewId: this.maxViewId,
          lastAllergenId: this.maxAllergenId,
          itemsList: this.items,
          views: this.views,
          allergens: this.allergens,
        };
        if (this.name) {
          Object.assign(data, { name: this.name });
        }
        if(this.selectedCompanyInfo && !this.selectedCompanyInfo.vatRates || (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.length === 0)){
          data.itemsList = [...this.parsedItemList]
        }
        let openMoadal = true;
        fetch(`${baseUrl}/catalog/create`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          body: JSON.stringify(data)
        })
          .then(response => response.json())
          .then((data) => {
            if(data.error && data.error === 'Forbidden'){
              this.creating = false;
              this.$router.push({name: 'logOut'});
              throw new Error('Failed to create catalog');
            }
            if(data.status === 'Failed'){
              this.creating = false;
              throw new Error(data.statusText);
            }
            this.err = '';
            this.activationData = {
              catalogId: data.catalogId,
              companyId: this.selectedCompany.id,
            }
            return this.$http.get(`catalog/${data.catalogId}`);
          })
          .catch(e=>{
            // this.$router.push({ name: "catalogList" });
            this.err = 'Error ' + e;
            openMoadal = false;
            throw new Error('abort');
          })
          .then((res) => {
            if (res.body.status !== 'Success') {
              throw new Error('Failed to fetch catalog');
            }
            const webview = this.getWebshopView();
            if (!webview) return null;
            this.activationData.catalogViewId = webview.viewId;
            this.activationData.catalogVersion = res.body.catalog.version;
            return this.$http.post('webshopresource/getall', { companyId: this.selectedCompany.id });
          })
          .then((res) => {
            if (res && res.body.status === 'Success') {
              this.activationData.webshops = res.body.details.filter(webshop => webshop.status === 'active');
            }
            this.showActivationModal = true;
          })
          .catch((err) => {
            if (openMoadal) {
              this.showActivationModal = true;
            }
          });
      },
      closeActivation() {
        this.showActivationModal = false;
        this.$router.push({ name: 'catalogList' });
      },
      validateBeforeCreateNewCatalog(){
        //Validate for Unique Items Id
        if (!this.selectedCompany) {
          this.err = this.$lang.errors.youMustSelectCompany;
          this.isCatalogValid = false;
          return;
        } else {
          this.isCatalogValid = true;
        }
        if(_.uniq(this.itemsIds).length === this.itemsIds.length){
          this.isCatalogValid = true;
          this.err = '';
        }else{
          this.notUniqItemsIds = _.transform(_.countBy(this.itemsIds), function(result, count, value) {
            if (count > 1) result.push(value);
          }, []);
          this.isCatalogValid = false;
          this.err = `All item id's should be unique, id ${this.notUniqItemsIds.toString()} is duplicated`;
          return;
        }
        //Validate if View all views ids exist
        let uniqViewsId = _.uniq(this.viewsIds);
        // let uniqViewsId = uniqViewsIndexes.map((view)=> this.views[view].viewId );
        let existViewsId = this.views.map((view)=>view.viewId);
        let notExistingViewsId = uniqViewsId.filter(e=>!existViewsId.includes(e));
        if(notExistingViewsId.length === 0){
          this.isCatalogValid = true;
          this.err = '';
        }else{
          this.isCatalogValid = false;
          this.err = `View with id ${notExistingViewsId[0]} does not exist. Please remove it from items`;
          return;
        }

        //Validate if View order types are used only once
        let tempViewOrderTypes = [];
        this.views = this.views.map((view) => {
          if (view.orderTypes && view.orderTypes.length > 0) {
            view.orderTypes.forEach(type => {
              if (tempViewOrderTypes.includes(type)) {
                this.isCatalogValid = false;
                this.err = `View Order Type '${type}' is duplicated in View: ${view.name.en || view.name.de}, please remove.`;
              }
            })
            tempViewOrderTypes.push(...view.orderTypes);
          }
          if (!view.orderTypes) view.orderTypes = [];
          return view;
        });
        if (this.err !== '') return;

        //Validate if vatRate exist in company


        //Valid current last Id is the highest
        if(Math.max(...this.itemsIds) > this.maxItemId){
          this.isCatalogValid = false;
          this.err = 'The highest item id is not the highest'
          return;
        }else{
          this.isCatalogValid = true;
          this.err = ''
        }
        //Valid current view Id is the highest
        if(Math.max(...uniqViewsId) > this.maxViewId){
          this.isCatalogValid = false;
          this.err = 'The highest view id is not the highest'
          return;
        }else{
          this.isCatalogValid = true;
          this.err = '';
        }

        // Valid if the last item have all required fields filled
        this.errors = [];
        this.parseAllItems(this.items);
        let sortedErrors = this.errors.sort((a,b)=>{
          if(a.itemName > b.itemName) return 1;
          else if(a.itemName < b.itemName) return -1;
          else return 0;
        });
        this.errors = sortedErrors;
      },
      fetchCatalog() {
        fetch(`${baseUrl}/catalog/${this.$route.query.id}`, {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
        }).then((response) => {
          return response.json();
        }).then((data) => {
          this.loaded = true;
          if(data.error && data.error === 'Forbidden'){
            this.$router.push({name: 'logOut'})
            return;
          }
          if (!this.isLocalAdmin) {
            this.selectedCompany = this.companies.find(company => company.id === data.catalog.companyId);
            this.currentCorporation = this.allCorporations.find(corporation =>
              corporation.companies.includes(this.selectedCompany.id));
          } else {
            this.selectedCompany = {
              id: data.catalog.companyId,
            };
          }
          this.name = data.catalog.name;
          this.version = data.catalog.version;
          this.views = data.catalog.views;
          this.selectedOrderTypes = data.catalog.views.map(x => x.orderTypes).flat(Infinity).filter( this.onlyUnique );
          this.allergens = data.catalog.allergens || [];
          this.renderExistItems(data.catalog.itemsList);
          this.validateItemIds(this.items);
          if (!this.isLocalAdmin) {
            this.fetchCompany();
          }
        }).catch((err)=>{
          this.err = err.message || err.body.message;
          // this.loaded = true;
          // this.selectedCompany = this.companies.find(company => company.id === fetch_data.catalog.catalog.companyId);
          // this.views = fetch_data.catalog.catalog.views;
          // this.renderExistItems(fetch_data.catalog.catalog.itemsList);
          // this.fetchCompany()
        });
      },
      renderExistItems(itemsList){
        let a = itemsList.map((item)=>{
          let itemRec = (itemParent) => {
            if(!itemParent.items){
              let parentItem = itemParent;
              let updatedItem = {
                ...itemParent,
                selected: false,
                parentItem
              }
              if (itemParent.taxCategory) {
                this.taxCategories.push(itemParent.taxCategory)
              }
              this.itemsIds.push(itemParent.itemId);
              this.viewsIds.push(...itemParent.views);
              if (itemParent.allergens) {
                this.allergensIds.push(...itemParent.allergens);
              }
              return updatedItem;
            }else{

              let childUpdated = itemParent.items.map((child)=>{
                if(!child.items){
                  let parentItem = itemParent;
                  if (child.taxCategory) {
                    this.taxCategories.push(child.taxCategory)
                  }
                  this.itemsIds.push(child.itemId);
                  this.viewsIds.push(...child.views);
                  if (child.allergens) {
                    this.allergensIds.push(...child.allergens);
                  }
                  return {
                    ...child,
                    selected: false,
                    parentItem
                  }
                }
                else {
                  return itemRec(child)
                }
              });


              let updatedItem = {
                ...itemParent,
                items: [...childUpdated],
                selected: false,
                parentItem: null
              }
              if (itemParent.taxCategory) {
                this.taxCategories.push(itemParent.taxCategory)
              }
              this.itemsIds.push(itemParent.itemId)
              this.viewsIds.push(...itemParent.views)
              if (itemParent.allergens) {
                this.allergensIds.push(...itemParent.allergens);
              }
              return updatedItem;
            }

          }
          let itemGood = itemRec(item);
          this.addItem({ ...itemGood, open: true });
        });
        if (this.taxCategories.length > 0) {
          this.taxCategories = this.taxCategories.filter( this.onlyUnique );
          this.taxCategories= this.taxCategories.filter(function (el) {
            return el != null;
          });
        }
      },
      onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      },
      parentInherit(childItem, parentItem, inheritProp){
        if(!parentItem || parentItem === undefined){
          return;
        }else{
          let inheritFromParent;
          //inherit arrays
          if(inheritProp !== 'vatRate'){
            inheritFromParent = (childItem, parentItem) => {
            if((!childItem[inheritProp] || childItem[inheritProp].length === 0) && (parentItem[inheritProp] && parentItem[inheritProp].length !== 0)){
              childItem[inheritProp] = parentItem[inheritProp]
            }else if((!childItem[inheritProp] || childItem[inheritProp].length === 0) && (!parentItem[inheritProp] || parentItem[inheritProp].length === 0) && parentItem.parentItem){
              return inheritFromParent(childItem, parentItem.parentItem);
            }
          }
          }else{
            //inherit strings
            inheritFromParent = (childItem, parentItem) => {
            if(childItem[inheritProp] || childItem[inheritProp] === 0){
              return;
            }
            if((!childItem[inheritProp] || childItem[inheritProp].length === 0) && (parentItem[inheritProp] && parentItem[inheritProp].length !== 0)){
              childItem[inheritProp] = parentItem[inheritProp]
            }else if((!childItem[inheritProp] || childItem[inheritProp].length === 0) && (!parentItem[inheritProp] || parentItem[inheritProp].length === 0) && parentItem.parentItem){
              return inheritFromParent(childItem, parentItem.parentItem);
            }
          }
          }

          inheritFromParent(childItem, parentItem)
        }
      },
      parseAllItems(itemsList){
        this.parsedItemList = itemsList.map((item)=>{
          let itemRec = (itemParent) => {
            if(!itemParent.items){
              let updatedItem = {
                ...itemParent,
                selected: false,
              }
              if(!this.selectedCompanyInfo.vatRates || (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates === null)){
                updatedItem = {
                  ...itemParent,
                selected: false,
                vatRate: null
                }
              }
              this.requiredFieldsValidation(updatedItem, false)
              return updatedItem;
            }else{

              let childUpdated = itemParent.items.map((child)=>{
                if(!child.items){
                let parsedChildItem = {
                  ...child,
                    selected: false,
                }
                if(!this.selectedCompanyInfo.vatRates || (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates === null)){
                  parsedChildItem = {
                    ...child,
                    selected: false,
                    vatRate: null
                  }
                }
                  this.requiredFieldsValidation(child, false)
                  return parsedChildItem;
                } else {
                  return itemRec(child)
                }
              });

              let updatedItem = {
                ...itemParent,
                items: [...childUpdated],
                selected: false,
                parentItem: null
              }
              if(!this.selectedCompanyInfo.vatRates || (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates === null)){
                  updatedItem = {
                    ...itemParent,
                    items: [...childUpdated],
                    selected: false,
                    parentItem: null,
                    vatRate: null
                  }
                }
              this.requiredFieldsValidation(updatedItem, true)
              return updatedItem;
            }
          }
          let itemGood = itemRec(item);
          return itemGood;
        });
      },
      returnExistingName(name) {
        if (name[this.selectedCompanyInfo.defaultLanguage]) return name[this.selectedCompanyInfo.defaultLanguage];
        if (name.en) return name.en;
        if (name.de) return name.de;
        if (name.zh) return name.zh;

      },
      requiredFieldsValidation(item, all){
        //Validate vatRate for all items
        let hasError = false;
        if((this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length > 0)){
          if(!item.vatRate && item.vatRate !== 0){
            this.parentInherit(item, item.parentItem, 'vatRate');
            if(!item.vatRate && item.vatRate !== 0){
              let errMessage = `Item with name ${item.name.en} dont have required field vatRate`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }

          }else if(item.vatRate || item.vatRate === 0){
            if(this.selectedCompanyInfo.vatRates.indexOf(+item.vatRate) === -1){
              let errMessage = `Item ${item.name.en} with Id ${item.itemId}: the vat rate ${item.vatRate} is not set for the company`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }else if( item.vatRate > 100 ){
              let errMessage = `Item ${item.name.en} with Id ${item.itemId}: the vat rate ${item.vatRate} is higher than 100`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }else if( item.vaRate < 0){
              let errMessage = `Item ${item.name.en} with Id ${item.itemId}: the vat rate ${item.vatRate} is lower than 0`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        }

        // Remove empty Description
        if (item.desc && Object.keys(item.desc).length > 0) {
          const tempObjKeys = Object.keys(item.desc);
          for (let i = 0; i < tempObjKeys.length; i += 1) {
            if (item.desc[tempObjKeys[i]] === '') delete item.desc[tempObjKeys[i]];
          }
          if (Object.keys(item.desc).length === 0) delete item['desc'];
        }

        // Remove empty Abbr
        if (item.abbr && Object.keys(item.abbr).length > 0) {
          const tempObjKeys = Object.keys(item.abbr);
          for (let i = 0; i < tempObjKeys.length; i += 1) {
            if (item.abbr[tempObjKeys[i]] === '') delete item.abbr[tempObjKeys[i]];
          }
          if (Object.keys(item.abbr).length === 0) delete item['abbr'];
        }

        //Validate Default language for all items
        if(item.desc && Object.keys(item.desc).length !== 0 && item.desc.constructor === Object && !item.desc[this.selectedCompanyInfo.defaultLanguage]){
          let errMessage = `Item with name ${this.returnExistingName(item.name)} (ID: ${item.itemId}) doesn't have Description in default language`
          let error = {
            itemName: item.name.en,
            message: errMessage
          }
          this.errors.push(error);
          this.isCatalogValid = false;
          hasError = true;
        }
        if(item.abbr && Object.keys(item.abbr).length !== 0 && item.abbr.constructor === Object && !item.abbr[this.selectedCompanyInfo.defaultLanguage]){
          let errMessage = `Item with name ${this.returnExistingName(item.name)} (ID: ${item.itemId}) doesn't have Abbreviation in default language`
          let error = {
            itemName: item.name.en,
            message: errMessage
          }
          this.errors.push(error);
          this.isCatalogValid = false;
          hasError = true;
        }
        if(item.name && !item.name[this.selectedCompanyInfo.defaultLanguage]){
          let errMessage = `Item with ID ${item.itemId} doesn't have Name in default language`
          let error = {
            itemName: item.name.en,
            message: errMessage
          }
          this.errors.push(error);
          this.isCatalogValid = false;
          hasError = true;
        }
        if(item.sizes && item.sizes.length > 0){
          for (const size of item.sizes) {
            if(size.name && !size.name[this.selectedCompanyInfo.defaultLanguage]){
              let errMessage = `Item with name ${this.returnExistingName(item.name)} (ID: ${item.itemId}) doesn't have Size '${this.returnExistingName(size.name)}' name in default language`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        }
        if(item.styles && item.styles.length > 0){
          for (const style of item.styles) {
            if(style.name && !style.name[this.selectedCompanyInfo.defaultLanguage]){
              let errMessage = `Item with name ${this.returnExistingName(item.name)} (ID: ${item.itemId}) doesn't have Style '${this.returnExistingName(style.name)}' name in default language`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        }
        if(item.variants && item.variants.length > 0){
          for (const variant of item.variants) {
            if(variant.name && !variant.name[this.selectedCompanyInfo.defaultLanguage]){
              let errMessage = `Item with name ${this.returnExistingName(item.name)} (ID: ${item.itemId}) doesn't have Variant '${this.returnExistingName(variant.name)}' name in default language`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        }
        if(item.options && item.options.length > 0){
          for (const option of item.options) {
            if(option.name && !option.name[this.selectedCompanyInfo.defaultLanguage]){
              let errMessage = `Item with name ${this.returnExistingName(item.name)} (ID: ${item.itemId}) doesn't have Option '${this.returnExistingName(option.name)}' name in default language`
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        }

        //Validate all other required items
        if(all !== true){
          if(!item['styles'] || item['styles'].length === 0){
            this.parentInherit(item, item.parentItem, 'styles')
            let errMessage = `Item with name ${item.name.en} dont have required field styles`
            if(!item['styles'] || item['styles'].length === 0){
              hasError = true;
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
            }

          }

          if(!item['sizes'] || item['sizes'].length === 0){
            this.parentInherit(item, item.parentItem, 'sizes');
            if(!item['sizes'] || item['sizes'].length === 0){
              let errMessage = `Item with name ${item.name.en} dont have required field sizes`
              hasError = true;
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
            }

          }

          if(!item['variants'] || item['variants'].length === 0){
            this.parentInherit(item, item.parentItem, 'variants')
            let errMessage = `Item with name ${item.name.en} dont have required field variants`
            if(!item['variants'] || item['variants'].length === 0){
              hasError = true;
              let error = {
                itemName: item.name.en,
                message: errMessage
              }
              this.errors.push(error);
              this.isCatalogValid = false;
            }

          }
        }
        if (hasError) {
          Vue.set(item, 'error', true);
        }
      },
      async removeErrors() {
        const remove = (item) => {
          if (item.items) {
            item.items.forEach(current => remove(current));
          }
          Vue.set(item, 'error', false);
        };
        this.items.forEach(item => remove(item));
      },
      validateItemIds(itemsList) {
        const ids = [];
        const duplicates = [];
        const errors = [];
        const findDuplicates = (list) => {
          list.forEach((item) => {
            if (ids.includes(item.itemId) && !duplicates.includes(item.itemId)) {
              duplicates.push(item.itemId);
            } else {
              ids.push(item.itemId);
            }
            if (item.items && item.items.length > 0) {
              findDuplicates(item.items);
            }
          });
        }
        const markErrors = (list) => {
          list.forEach((item) => {
            if (duplicates.includes(item.itemId)) {
              errors.push(`Item ${item.name[this.language]} does not have a unique Id (${item.itemId})!`);
              this.$set(item, 'error', true);
            }
            if (item.items && item.items.length > 0) {
              markErrors(item.items);
            }
          });
        }
        findDuplicates(itemsList);
        markErrors(itemsList);

        if (errors.length > 0) {
          this.err = errors.join('. ');
        }
      },
      fetchCompanies() {
        return new Promise((resolve) => {
          fetch(`${baseUrl}/company`, {
            method: 'get',
            credentials: 'include',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then((response) => {
            return response.json();
          }).then((data) => {
            if(data.error && data.error === 'Forbidden'){
              this.$router.push({name: 'logOut'})
              resolve();
              return;
            }
            this.companies = data.companies;
            if (this.isLocalAdmin) {
              this.selectedCompany = this.companies[0];
            }
            resolve();
          }).catch((e)=>{
            this.companies = fetch_data.companies;
            resolve();
          })
        });
      },
      fetchCompany(){
       fetch(`${baseUrl}/company/${this.selectedCompany.id}`, {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
        }).then((response) => {
          return response.json();
        }).then((data) => {
          if(data.error && data.error === 'Forbidden') {
            this.$router.push({name: 'logOut'})
            return;
          }
          this.selectedCompanyInfo = data.company;
         if (this.selectedCompanyInfo && this.selectedCompanyInfo.defaultLanguage) this.$cookie.set('lang', this.selectedCompanyInfo.defaultLanguage)
        }).catch((e)=>{
          this.selectedCompanyInfo = fetch_data.company;
        })
      },
      initialViewsOnNewCatalog(){
        this.views = [
          {"viewId":1,"name":{"en":"Collection","de":"Collection"}, "orderTypes": ['collection']},
          {"viewId":2,"name":{"en":"Webshop","de":"Webshop"}, "orderTypes": ['delivery']},
          {"viewId":3,"name":{"en":"Takeaway","de":"Takeaway"}, "orderTypes": ['takeaway']},
          {"viewId":4,"name":{"en":"Restaurant","de":"Restaurant"}, "orderTypes": ['restaurant']},
          {"viewId":5,"name":{"en":"Self-service","de":"Self-service"}, "orderTypes": []},
          {"viewId":6,"name":{"en":"Simple-inventory","de":"Simple-inventory"}, "orderTypes": []},
          {"viewId":7,"name":{"en":"Full-inventory","de":"Full-inventory"}, "orderTypes": []},
          ];
        this.selectedOrderTypes = ['collection', 'delivery', 'takeaway', 'restaurant'];
      },
      getWebshopView() {
        let webview;
        this.views.forEach((view) => {
          if (view.name.en === 'Webshop') webview = view;
        });
        return webview;
      },
      async fetchCorporations() {
        try {
          const res = await this.$http.get('corporation/getall')
          if (res.body.status !== 'Success') {
            throw new Error(res.body.statusText);
          }
          this.allCorporations = res.body.corporations;
        } catch (err) {
          this.err = err.message || err.body.message;
        }
      },
      async getOrderTypes() {
        this.$http.get('system/ordertypes')
          .then((res) => {
            if (res.body.status === 'Success') {
              this.orderTypes = res.body.moon;
              return;
            }
            this.orderTypes = ['collection', 'delivery', 'takeaway', 'restaurant'];
            this.err = res.body.statusText;
          }, (err) => {
            this.orderTypes = ['collection', 'delivery', 'takeaway', 'restaurant'];
            this.err = err.body.statusText || err.body.message;
          });
      },
      initialAllergens() {
        this.allergens = allergensData;
      },
    },

    beforeDestroy() {
      document.removeEventListener('paste', this.pasteWholeCatalog);
    },

    async created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      await this.fetchCompanies();
      await this.getOrderTypes();
      if (this.isLocalAdmin) {
        if (this.$route.query.id){
          await this.fetchCatalog();
          this.isEdit = true;
        } else {
          this.initialViewsOnNewCatalog();
          this.initialAllergens();
        }
        return;
      }
      await this.fetchCorporations();
      if (this.$route.query.id){
        await this.fetchCatalog();
        this.isEdit = true;
      } else {
        this.initialViewsOnNewCatalog();
        this.initialAllergens();
        this.selectedCompany = this.$cookie.get('companyedit') ?
          this.companies.find(company => company.id === this.$cookie.get('companyedit')) :
          null;
        if (this.selectedCompany && this.selectedCompany.defaultLanguage) this.$cookie.set('lang', this.selectedCompany.defaultLanguage)
      }
    },
    components: {
      itemModal: () => import('../modals/SingleItem'),
      viewModal: () => import('../modals/ViewsModal'),
      allergenModal: () => import('../modals/AllergensModal'),
      vatModal: () => import('../modals/MassVATAddModal'),
      viewsModal: () => import('../modals/MassViewsAddModal'),
      allergensModal: () => import('../modals/MassAllergensAddModal'),
      printersModal: () => import('../modals/MassPrintersAddModal'),
      langTransModal: () => import('../modals/MassAllItemsLanguage'),
      activationModal: () => import('../modals/CatalogActivationModal'),
      confirmationModal: () => import('../modals/ConfirmationModal'),
      massAddModal: () => import('../modals/MassAddModal'),
      massRemoveModal: () => import('../modals/MassRemoveModal'),
      addPredefinedViews: () => import('../modals/AddPredefinedViews'),
    },
  };
</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
  }
  .show-buttons {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  .views {
    border: 2px dashed rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    p {
      text-align: center;
      color: rgba(0, 0, 0, 0.4);
      cursor: pointer;
    }
    &--item {
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .btn {
      height: auto;
    }
    .icon {
      color: #fff;
      font-size: 1.5rem;
      padding: 0.5rem;
      border-radius: 4px;
      background-color: #007EFA;
      cursor: pointer;
      &:last-of-type {
        background-color: #C52837;
      }
    }
  }
  .loading {
    position: absolute;
    top: 0;
    margin: 0;
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 4;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// Single.vue?7f0d45fe